












    import {Vue, Component, Prop} from 'vue-property-decorator';
    import {MenuItem} from "@/models/MenuItem";

    @Component({
		name: "MenuItemControl"
	})
	export default class MenuItemControl extends Vue{
		@Prop()
		item: MenuItem;
    }
